import React from "react";

export default function NewChatModal({
  newChatPhone,
  setNewChatPhone,
  newChatName,
  setNewChatName,
  onClose,
  onSubmit,
}) {
  return (
    <div className="v-modal-backdrop" onClick={onClose} role="dialog" aria-modal="true">
      <div className="v-modal-box sm" onClick={(e) => e.stopPropagation()}>
        <div className="v-modal-header">
          <div className="v-modal-title">
            <i className="bi bi-chat-plus-fill text-maroon me-2"></i>
            <span>New Conversation</span>
          </div>
          <button type="button" className="v-btn-icon-close" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>

        <form onSubmit={onSubmit}>
          <div className="v-modal-body">
            <p className="v-modal-subtitle">
              Enter customer mobile number to open or initiate a conversation via Meta WhatsApp Cloud API.
            </p>

            <div className="mb-3">
              <label className="form-label fw-bold small text-secondary">
                WhatsApp Mobile Number (10 digits) <span className="text-danger">*</span>
              </label>
              <div className="input-group">
                <span className="input-group-text bg-light text-muted fw-bold">+91</span>
                <input
                  type="tel"
                  className="form-control"
                  placeholder="e.g. 9840123456"
                  value={newChatPhone}
                  onChange={(e) => setNewChatPhone(e.target.value)}
                  required
                  autoFocus
                />
              </div>
            </div>

            <div className="mb-2">
              <label className="form-label fw-bold small text-secondary">
                Contact Name (Optional)
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="e.g. S. Ramanathan"
                value={newChatName}
                onChange={(e) => setNewChatName(e.target.value)}
              />
            </div>
          </div>

          <div className="v-modal-footer">
            <button type="button" className="btn btn-sm btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="v-btn-primary">
              <i className="bi bi-chat-dots-fill me-1"></i>
              <span>Open Conversation</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
